import { Address } from '../types';

const makeAddressesFormat = (response: { Data?: Record<string, unknown>[] } | Record<string, unknown>[]): Address[] => {
  const raw = Array.isArray(response) ? response : response?.Data || [];
  return raw.map((a) => ({
    Id: Number(a.Id) || 0,
    Title: String(a.Title || ''),
    TypeId: Number(a.TypeId) || 0,
    TypeTitle: String(a.TypeTitle || ''),
    Line1: String(a.Line1 || ''),
    Line2: String(a.Line2 || ''),
    City: String(a.City || ''),
    Province: String(a.Province || ''),
    PostalCode: String(a.PostalCode || ''),
    Country: String(a.Country || ''),
    CustomerId: Number(a.CustomerId) || 0,
    PatrolType: String(a.PatrolType || ''),
    Instructions: String(a.Instructions || ''),
    OnlineMapUrl: String(a.OnlineMapUrl || ''),
  }));
};

export default makeAddressesFormat;
